// extracted by mini-css-extract-plugin
export default {"number_sec":"number_number_sec__ZoSe1","number_row":"number_number_row__60Lks","number_text":"number_number_text__YfQmV","number_col":"number_number_col__FUe-O"};